import React from 'react';

export const CheckMark = ({ color = '#000000' }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5004 1.8894C13.8223 2.15012 13.8718 2.6224 13.6111 2.94426L7.13101 10.9443L6.60854 11.5893L6.01964 11.0043L2.99975 8.00427C2.70589 7.71235 2.70432 7.23748 2.99624 6.94362C3.28816 6.64976 3.76303 6.64819 4.05689 6.94011L6.4879 9.3551L12.4455 2.00012C12.7062 1.67825 13.1785 1.62868 13.5004 1.8894Z"
      fill={color}
    />
  </svg>
);

export const DoubleCheckMark = ({ color = '#000000' }) => (
  <div style={{ marginTop: -4 }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path
        fill={color}
        d="M2.394 13.742L7.137 17.362 14.753 8.658 13.247 7.342 6.863 14.638 3.606 12.152zM21.753 8.658L20.247 7.342 13.878 14.621 13.125 14.019 11.875 15.581 14.122 17.379z"
      />
    </svg>
  </div>
);
